export function studentPlatformPath(partnerUuid: string, studentId: string, route: string): string {
  return `/student-platform/${partnerUuid}/${studentId}/${route}`;
}

export function studentPlatformUrl(
  cfAppUrl: string,
  partnerUuid: string,
  studentId: string,
  route: string,
  sourceUrl?: string,
  fromJourney?: boolean,
  primarySource?: string,
  fifthStepVisible?: boolean,
): string {
  const base = `${cfAppUrl}${studentPlatformPath(partnerUuid, studentId, route)}`;
  const params = new URLSearchParams();
  if (sourceUrl) params.set('sourceUrl', sourceUrl);
  if (fromJourney) params.set('fromJourney', '1');
  if (primarySource) params.set('primarySource', primarySource);
  if (fifthStepVisible !== undefined) params.set('fifthStepVisible', fifthStepVisible ? '1' : '0');
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function signUpUrl(cfAppUrl: string, partnerUuid: string, prefs?: string, email?: string, sourceUrl?: string, primarySource?: string, fifthStepVisible?: boolean): string {
  const base = `${cfAppUrl}/student-platform/${partnerUuid}/sign-up`;
  const params = new URLSearchParams();
  if (prefs) params.set('prefs', prefs);
  if (email) params.set('email', email);
  if (sourceUrl) params.set('sourceUrl', sourceUrl);
  if (primarySource) params.set('primarySource', primarySource);
  if (fifthStepVisible !== undefined) params.set('fifthStepVisible', fifthStepVisible ? '1' : '0');
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}
